const translations = {
    headerTitle: {
        type: 'text',
        defaultValue: '<b>Welcome</b> to FizjoAI',
    },
    headerDescription: {
        type: 'text',
        defaultValue: 'To receive access to the FizjoAI platform, please fill out the registration form below. After completing it, we will notify you by email about the next stages of registration.',
    },
    titleCompany: {
        type: 'text',
        defaultValue: 'Company information:',
    },
    titlePerson: {
        type: 'text',
        defaultValue: 'Personal information:',
    },
    titlePersonGoogle: {
        type: 'text',
        defaultValue: 'Personal information received from Google account:',
    },
    inputCompanyName: {
        type: 'text',
        defaultValue: 'Company name',
    },
    inputVatId: {
        type: 'text',
        defaultValue: 'Company VAT ID',
    },
    inputCity: {
        type: 'text',
        defaultValue: 'City',
    },
    inputPostCode: {
        type: 'text',
        defaultValue: 'Postal code',
    },
    inputStreet: {
        type: 'text',
        defaultValue: 'Street',
    },
    inputHomeNo: {
        type: 'text',
        defaultValue: 'House number',
    },
    inputFlatNo: {
        type: 'text',
        defaultValue: 'Apartment number',
    },
    inputFirstName: {
        type: 'text',
        defaultValue: 'First name',
    },
    inputLastName: {
        type: 'text',
        defaultValue: 'Last name',
    },
    inputEmail: {
        type: 'text',
        defaultValue: 'Email',
    },
    inputPhone: {
        type: 'text',
        defaultValue: 'Phone',
    },
    submitButton: {
        type: 'text',
        defaultValue: 'Register',
    },
    resultFormTitle: {
        type: 'text',
        defaultValue: 'Thank you!',
    },
    resultFormDescription: {
        type: 'text',
        defaultValue: 'Thank you for filling out the registration form. Your registration request has been forwarded to our administrator. <br/><br/> We will notify you by email about the next steps.',
    },
    resultFormButton: {
        type: 'text',
        defaultValue: 'Return to the home page',
    },
    googleError: {
        type: 'text',
        defaultValue: 'Sorry, linking the selected Google account is not possible at this time',
    },
    googleHeadline: {
        type: 'text',
        defaultValue: 'Optionally link your Google account to log in with it:',
    },
    googleHeadlineBind: {
        type: 'text',
        defaultValue: 'The created account will be linked with the selected Google account:',
    },
    googleSubTitleBind: {
        type: 'text',
        defaultValue: 'Check the accuracy of the received data.',
    },
};

export default translations;
